
export default function ConsultationServices() {
  const services = [
    {
      id: 'investment-consultation',
      title: 'Investment Strategy Consultation',
      price: 150,
      duration: '60 minutes',
      description: 'Comprehensive investment strategy planning for glamping retreats and tiny home developments.',
      features: [
        'Market opportunity analysis',
        'ROI projections and financial modeling',
        'Risk assessment and mitigation strategies',
        'Portfolio diversification recommendations',
        'Exit strategy planning'
      ],
      icon: 'ri-line-chart-line'
    },
    {
      id: 'property-development',
      title: 'Property Development Consultation',
      price: 200,
      duration: '75 minutes',
      description: 'Expert guidance on property development, zoning, permits, and construction planning.',
      features: [
        'Site selection and evaluation',
        'Zoning and permit requirements',
        'Construction timeline and budgeting',
        'Contractor and vendor recommendations',
        'Regulatory compliance guidance'
      ],
      icon: 'ri-building-line'
    },
    {
      id: 'business-planning',
      title: 'Business Planning Session',
      price: 175,
      duration: '60 minutes',
      description: 'Strategic business planning for glamping operations, marketing, and growth strategies.',
      features: [
        'Business model development',
        'Marketing and branding strategy',
        'Operational planning and systems',
        'Revenue optimization strategies',
        'Scaling and expansion planning'
      ],
      icon: 'ri-briefcase-line'
    },
    {
      id: 'market-analysis',
      title: 'Market Analysis Review',
      price: 125,
      duration: '45 minutes',
      description: 'In-depth market analysis for specific locations and target demographics.',
      features: [
        'Local market demand assessment',
        'Competitive landscape analysis',
        'Pricing strategy recommendations',
        'Seasonal trends and patterns',
        'Growth potential evaluation'
      ],
      icon: 'ri-bar-chart-line'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Professional Consultation Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Choose from our specialized consultation services designed to accelerate your 
            glamping investment success with expert guidance and proven strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service) => (
            <div key={service.id} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="flex items-start justify-between mb-6">
                <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center">
                  <i className={`${service.icon} text-2xl text-emerald-600`}></i>
                </div>
                <div className="text-right">
                  <div className="text-3xl font-bold text-emerald-600">${service.price}</div>
                  <div className="text-sm text-gray-500">{service.duration}</div>
                </div>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6">{service.description}</p>

              <div className="mb-8">
                <h4 className="font-semibold text-gray-900 mb-3">What's Included:</h4>
                <ul className="space-y-2">
                  {service.features.map((feature, index) => (
                    <li key={index} className="flex items-center text-gray-600">
                      <i className="ri-check-line text-emerald-600 mr-3"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>

              <a 
                href="#booking"
                className="w-full bg-emerald-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap text-center block"
              >
                Book This Service
              </a>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-emerald-50 rounded-xl p-8 text-center">
          <h3 className="text-2xl font-bold text-emerald-800 mb-4">Why Choose Our Consultation Services?</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-award-line text-2xl text-white"></i>
              </div>
              <h4 className="font-semibold text-emerald-800 mb-2">Industry Expertise</h4>
              <p className="text-emerald-700">Over 10 years of experience in glamping and tiny home investments</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-star-line text-2xl text-white"></i>
              </div>
              <h4 className="font-semibold text-emerald-800 mb-2">Personalized Approach</h4>
              <p className="text-emerald-700">Tailored strategies based on your specific goals and circumstances</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-emerald-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-rocket-line text-2xl text-white"></i>
              </div>
              <h4 className="font-semibold text-emerald-800 mb-2">Proven Results</h4>
              <p className="text-emerald-700">Track record of successful projects and satisfied investors</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
